/** Grapheme mapping preserves offsets through width conversion and combining characters. */
export const SEARCH_INDEX_VERSION = 2 as const;
export function indexText(text: string) {
  let normalized = "";
  const positions: number[] = [];
  for (const { segment, index } of new Intl.Segmenter("und", {
    granularity: "grapheme",
  }).segment(text)) {
    const value = segment.normalize("NFKC").toLocaleLowerCase("und");
    normalized += value;
    positions.push(...Array(value.length).fill(index));
  }
  return {
    normalized,
    positions,
    grams: [
      ...new Set(
        Array.from({ length: Math.max(0, normalized.length - 1) }, (_, i) =>
          normalized.slice(i, i + 2),
        ),
      ),
    ],
    indexVersion: SEARCH_INDEX_VERSION,
  };
}
export function snippet(text: string, query: string) {
  const indexed = indexText(text),
    at = indexed.normalized.indexOf(
      query.normalize("NFKC").toLocaleLowerCase("und"),
    );
  const original = at < 0 ? 0 : indexed.positions[at];
  return text.slice(
    Math.max(0, original - 35),
    Math.max(0, original - 35) + 120,
  );
}
